import React from "react";
import I18nHOC from "UIComponents/I18nHOC";
import { EmptyState } from "@toddle-edu/ds-web";
import { EvidenceIllustration } from "@toddle-edu/ds-theme";

const NoEvidenceView = props => {
  const { t, isSuggestedEvidencesTab } = props;

  const label = isSuggestedEvidencesTab
    ? t("snp:no_evidence_suggested")
    : t("snp:no_evidence_created");

  return (
    <EmptyState
      dsVersion="2.0"
      title={label}
      illustration={EvidenceIllustration}
    />
  );
};

export default I18nHOC({ resource: ["snp"] })(NoEvidenceView);

NoEvidenceView.defaultProps = {
  isSuggestedEvidencesTab: false,
};
